module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content.hero_slider) ? _c('div', {
    staticClass: "home-hero"
  }, [_c('div', {
    directives: [{
      name: "home-hero-directive",
      rawName: "v-home-hero-directive"
    }],
    staticClass: "home-hero__slider"
  }, _vm._l((_vm.content.hero_slider), function(slide) {
    return _c('div', {
      staticClass: "home-hero__slide",
      style: ({
        backgroundImage: "url(" + slide.photo + ")"
      })
    })
  }), 0), _c('div', {
    staticClass: "home-hero__divider"
  }), _c('div', {
    staticClass: "home-hero__tagline"
  }, [_c('div', {
    staticClass: "home-hero__tagline-col home-hero__tagline-left"
  }, [_c('a', {
    staticClass: "home-hero__tagline-title",
    attrs: {
      "href": "",
      "title": "Orthodontics Popup"
    }
  }, [_vm._v("Orthodontics")]), _c('div', {
    staticClass: "btn-main home-hero__tagline-link",
    on: {
      "click": function($event) {
        _vm.showScheduleModal = true
      }
    }
  }, [_vm._v("Schedule Consultation")])]), _c('div', {
    staticClass: "home-hero__tagline-col home-hero__tagline-right"
  }, [_c('a', {
    staticClass: "home-hero__tagline-title",
    attrs: {
      "href": "",
      "title": "Pediatric Dentistry Popup"
    }
  }, [_vm._v("Pediatric Dentistry")]), _c('div', {
    staticClass: "btn-main home-hero__tagline-link",
    on: {
      "click": function($event) {
        _vm.showApptModal = true
      }
    }
  }, [_vm._v("Make an Appointment")])])]), (_vm.showApptModal) ? _c('ApptModal', {
    on: {
      "close": function($event) {
        _vm.showApptModal = false
      }
    }
  }) : _vm._e(), (_vm.showScheduleModal) ? _c('ScheduleModal', {
    on: {
      "close": function($event) {
        _vm.showScheduleModal = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b5baca","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-hero/custom-home-hero.pug
// module id = 628
// module chunks = 1